module.exports = __webpack_public_path__ + "img/cover_2022.ef70f0ac.jpg";